module.exports = __webpack_public_path__ + "img/yellowRose.749e8592.jpg";